/**
 * @module
 * @description Content Modules
 */

import pageSidebar from './page/sidebar'
import navigation from './header/navigation'
import searchModal from './header/search'
import sticky from './header/sticky'
import modules from './modules/index'

const init = () => {
	pageSidebar()
	navigation()
	searchModal()
	sticky()
	modules()
}

const mba = '.mba-btn a'
const ms = '.ms-btn a'
const contentWrap = '.content-wrap'

$(mba).click(function () {
	$(contentWrap).toggleClass('mba-open')
})
$(ms).click(function () {
	$(contentWrap).toggleClass('ms-open')
})

export default init
